export const POST_QUERY_REQUEST = "POST_QUERY_REQUEST";
export const POST_QUERY_SUCCESS = "POST_QUERY_SUCCESS";
export const POST_QUERY_ERROR = "POST_QUERY_ERROR";


export const POST_QUERY_API_REQUEST = "POST_QUERY_API_REQUEST";
export const POST_QUERY_API_SUCCESS = "POST_QUERY_API_SUCCESS";
export const POST_QUERY_API_ERROR = "POST_QUERY_API_ERROR";


export const POST_QUERY_ARHAM_REQUEST = "POST_QUERY_ARHAM_REQUEST";
export const POST_QUERY_ARHAM_SUCCESS = "POST_QUERY_ARHAM_SUCCESS";
export const POST_QUERY_ARHAM_ERROR = "POST_QUERY_ARHAM_ERROR";